import type { GridRowId, GridRowSelectionModel } from './types';

export function selectedIds(model: GridRowSelectionModel, allIds: GridRowId[]): Set<GridRowId> {
  return model.type === 'include'
    ? new Set(model.ids)
    : new Set(allIds.filter((id) => !model.ids.has(id)));
}
/** Toggle only eligible visible rows; hidden selections and disabled duplicate rows survive. */
export function toggleVisibleSelection(
  selected: Set<GridRowId>,
  visibleSelectableIds: GridRowId[],
): Set<GridRowId> {
  const next = new Set(selected);
  const checked =
    visibleSelectableIds.length > 0 && visibleSelectableIds.every((id) => selected.has(id));
  visibleSelectableIds.forEach((id) => (checked ? next.delete(id) : next.add(id)));
  return next;
}
/** Fixed columns cannot move, and movable columns cannot be inserted ahead of them. */
export function moveColumn(
  order: string[],
  source: string,
  target: string,
  fixed: Set<string>,
): string[] {
  if (
    source === target ||
    fixed.has(source) ||
    fixed.has(target) ||
    !order.includes(source) ||
    !order.includes(target)
  )
    return order;
  const next = [...order];
  next.splice(next.indexOf(source), 1);
  next.splice(order.indexOf(target), 0, source);
  // Do not move a fixed column indirectly by dragging across it.
  if (order.some((field, index) => fixed.has(field) && next[index] !== field)) return order;
  return next;
}
